@file:OptIn(InternalResourceApi::class)

package portfolio.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/portfolio.composeapp.generated.resources/"

internal val Res.drawable.food_delivery_image: DrawableResource by lazy {
      DrawableResource("drawable:food_delivery_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/food_delivery_image.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_code_50: DrawableResource by lazy {
      DrawableResource("drawable:icons8_code_50", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-code-50.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_database_50: DrawableResource by lazy {
      DrawableResource("drawable:icons8_database_50", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-database-50.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_dev_96: DrawableResource by lazy {
      DrawableResource("drawable:icons8_dev_96", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-dev-96.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_experiment_50: DrawableResource by lazy {
      DrawableResource("drawable:icons8_experiment_50", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-experiment-50.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_github_48: DrawableResource by lazy {
      DrawableResource("drawable:icons8_github_48", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-github-48.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_gmail_50: DrawableResource by lazy {
      DrawableResource("drawable:icons8_gmail_50", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-gmail-50.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_layers_48: DrawableResource by lazy {
      DrawableResource("drawable:icons8_layers_48", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-layers-48.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_linkedin_48: DrawableResource by lazy {
      DrawableResource("drawable:icons8_linkedin_48", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-linkedin-48.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_menu_96: DrawableResource by lazy {
      DrawableResource("drawable:icons8_menu_96", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-menu-96.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_smartphone_50: DrawableResource by lazy {
      DrawableResource("drawable:icons8_smartphone_50", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-smartphone-50.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_thunder_48: DrawableResource by lazy {
      DrawableResource("drawable:icons8_thunder_48", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-thunder-48.webp", -1, -1),
      ))
    }

internal val Res.drawable.icons8_world_24: DrawableResource by lazy {
      DrawableResource("drawable:icons8_world_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/icons8-world-24.webp", -1, -1),
      ))
    }

internal val Res.drawable.photo_editor_image: DrawableResource by lazy {
      DrawableResource("drawable:photo_editor_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/photo_editor_image.webp", -1, -1),
      ))
    }

internal val Res.drawable.portfolio_image: DrawableResource by lazy {
      DrawableResource("drawable:portfolio_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/portfolio_image.webp", -1, -1),
      ))
    }

internal val Res.drawable.profile_foto: DrawableResource by lazy {
      DrawableResource("drawable:profile_foto", setOf(
        ResourceItem(setOf(), "${MD}drawable/profile_foto.webp", -1, -1),
      ))
    }

internal val Res.drawable.travel_blog_image: DrawableResource by lazy {
      DrawableResource("drawable:travel_blog_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/travel_blog_image.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectWebMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("food_delivery_image", Res.drawable.food_delivery_image)
  map.put("icons8_code_50", Res.drawable.icons8_code_50)
  map.put("icons8_database_50", Res.drawable.icons8_database_50)
  map.put("icons8_dev_96", Res.drawable.icons8_dev_96)
  map.put("icons8_experiment_50", Res.drawable.icons8_experiment_50)
  map.put("icons8_github_48", Res.drawable.icons8_github_48)
  map.put("icons8_gmail_50", Res.drawable.icons8_gmail_50)
  map.put("icons8_layers_48", Res.drawable.icons8_layers_48)
  map.put("icons8_linkedin_48", Res.drawable.icons8_linkedin_48)
  map.put("icons8_menu_96", Res.drawable.icons8_menu_96)
  map.put("icons8_smartphone_50", Res.drawable.icons8_smartphone_50)
  map.put("icons8_thunder_48", Res.drawable.icons8_thunder_48)
  map.put("icons8_world_24", Res.drawable.icons8_world_24)
  map.put("photo_editor_image", Res.drawable.photo_editor_image)
  map.put("portfolio_image", Res.drawable.portfolio_image)
  map.put("profile_foto", Res.drawable.profile_foto)
  map.put("travel_blog_image", Res.drawable.travel_blog_image)
}
